// Helper functions for interaction with AWS Cognito

// get currently authenticate user
export function cognito_session(current_user) {
  return new Promise((resolve, reject) => {
    current_user.getSession(function(err, session) {
      if (err) {
        reject(err);
      } else {
        resolve(session);
      }
    });
  });
}

// register user in AWS Cognito
export function cognito_register(
  user_pool,
  username,
  password,
  attributes_list
) {
  return new Promise((resolve, reject) => {
    user_pool.signUp(username, password, attributes_list, null, function(
      err,
      result
    ) {
      if (err) {
        reject(err);
        return;
      }
      resolve(result);
      return;
    });
  });
}

// login into AWS Cognito
export function cognito_login(cognito_user, authentication_details) {
  return new Promise((resolve, reject) => {
    cognito_user.authenticateUser(authentication_details, {
      onSuccess: function(result) {
        console.log("Cognito success");
        resolve(result);
        return;
      },
      onFailure: function(err) {
        console.log("Cognito failure");
        reject(err);
        return;
      }
    });
  });
}

// get user attributes
export function cognito_user_data(cognito_user) {
  return new Promise((resolve, reject) => {
    cognito_user.getUserAttributes(function(err, result) {
      if (err) {
        console.log("Failed getting user attribures:", err);
        reject(err);
        return;
      }
      resolve(result);
      return;
    });
  });
}

//forgot password
export function cognito_forgot_password(cognito_user) {
  return new Promise((resolve, reject) => {
    cognito_user.forgotPassword({
      onSuccess: function(result) {
        resolve(result);
        return;
      },
      onFailure: function(err) {
        reject(err);
        return;
      }
    });
  });
}

//forgot password confirm
export function cognito_forgot_password_confirm(
  cognito_user,
  verification_code,
  password
) {
  return new Promise((resolve, reject) => {
    cognito_user.confirmPassword(verification_code, password, {
      onSuccess: function(result) {
        resolve(result);
        return;
      },
      onFailure: function(err) {
        console.log(err);
        reject(err);
        return;
      }
    });
  });
}

//cognito confirm registration
export function cognito_confirm_registration(cognito_user, verification_code) {
  return new Promise((resolve, reject) => {
    cognito_user.confirmRegistration(verification_code, true, function(
      err,
      result
    ) {
      if (err) {
        reject(err);
        return;
      }
      resolve(result);
      return;
    });
  });
}
